module.exports = __webpack_public_path__ + "static/img/Slider_2_mobile.6c251d3f.jpg";